/*
  Японские Google Fonts, доступные в редакторе обложек.
  Список согласован с клиентом (Google Fonts 日本語フォント完全見本帳).
*/

const JAPANESE_FONTS = [
  { name: 'Noto Sans JP', label: 'Noto Sans JP', fallback: 'sans-serif', weights: [100, 300, 400, 700] },
  { name: 'Zen Kaku Gothic New', label: 'Zen 角ゴシック', fallback: 'sans-serif', weights: [400, 700] },
  { name: 'M PLUS 1p', label: 'M PLUS 1p', fallback: 'sans-serif', weights: [400, 700] },
  { name: 'BIZ UDGothic', label: 'BIZ UDゴシック', fallback: 'sans-serif', weights: [400, 700] },
  { name: 'Noto Serif JP', label: 'Noto Serif JP', fallback: 'serif', weights: [400, 700] },
  { name: 'Shippori Mincho', label: 'しっぽり明朝', fallback: 'serif', weights: [400, 700] },
  { name: 'Zen Maru Gothic', label: 'Zen 丸ゴシック', fallback: 'sans-serif', weights: [400, 700] },
  { name: 'M PLUS Rounded 1c', label: 'M PLUS Rounded', fallback: 'sans-serif', weights: [400, 700] },
  { name: 'Kiwi Maru', label: 'キウイ丸', fallback: 'serif', weights: [400] },
  { name: 'Klee One', label: 'クレー One', fallback: 'cursive', weights: [400, 600] },
  { name: 'Yomogi', label: 'よもぎ', fallback: 'cursive', weights: [400] },
  { name: 'Yusei Magic', label: '油性マジック', fallback: 'sans-serif', weights: [400] },
  { name: 'Hachi Maru Pop', label: 'はちまるポップ', fallback: 'cursive', weights: [400] },
  { name: 'Mochiy Pop One', label: 'モッチーポップ', fallback: 'sans-serif', weights: [400] },
  { name: 'Potta One', label: 'ポッタ One', fallback: 'cursive', weights: [400] },
  { name: 'Dela Gothic One', label: 'デラゴシックワン', fallback: 'cursive', weights: [400] },
  { name: 'Reggae One', label: 'レゲエ One', fallback: 'cursive', weights: [400] },
  { name: 'RocknRoll One', label: 'ロックンロール', fallback: 'sans-serif', weights: [400] },
  { name: 'Rampart One', label: 'ランパート One', fallback: 'cursive', weights: [400] },
  { name: 'Shizuru', label: 'シズル', fallback: 'cursive', weights: [400] },
  { name: 'Train One', label: 'Train One', fallback: 'cursive', weights: [400] },
  { name: 'Kaisei Decol', label: '解星デコール', fallback: 'serif', weights: [400, 700] },
  { name: 'Kaisei Opti', label: '解星オプティ', fallback: 'serif', weights: [400, 700] },
  { name: 'Monomaniac One', label: 'モノマニアック', fallback: 'sans-serif', weights: [400] }
]

/* Размеры шрифта для дропдауна редактора обложки: 7pt–70pt (требование клиента). */
const MIN_FONT_SIZE_PT = 7
const MAX_FONT_SIZE_PT = 70

function getFontSizes () {
  const result = []

  for (let size = MIN_FONT_SIZE_PT; size <= MAX_FONT_SIZE_PT; size++) {
    result.push(`${size}pt`)
  }

  return result
}

/* Значение для CSS font-family: '"Shippori Mincho", serif' */
function getFontFamily (font) {
  return `"${font.name}", ${font.fallback}`
}

/*
  <link> на Google Fonts со всеми семьями. Подключается в layout страниц обложки
  (не в общий layout шаблона), чтобы обычные страницы не тянули лишний CSS.
*/
function getGoogleFontsUrl (fonts = JAPANESE_FONTS) {
  const families = fonts
    .map((font) => {
      const family = font.name.replaceAll(' ', '+')
      return font.weights.length > 1
        ? `family=${family}:wght@${font.weights.join(';')}`
        : `family=${family}`
    })
    .join('&')

  return `https://fonts.googleapis.com/css2?${families}&display=swap`
}

function getGoogleFontsLink (fonts = JAPANESE_FONTS) {
  return [
    '<link rel="preconnect" href="https://fonts.googleapis.com">',
    '<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>',
    `<link href="${getGoogleFontsUrl(fonts)}" rel="stylesheet">`
  ].join('\n')
}

export {
  JAPANESE_FONTS,
  MIN_FONT_SIZE_PT,
  MAX_FONT_SIZE_PT,
  getFontSizes,
  getFontFamily,
  getGoogleFontsUrl,
  getGoogleFontsLink
}
